// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import routes from './router'
import vuetify from '@/plugins/vuetify'
import store from './store'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

Vue.config.productionTip = false
const router = new VueRouter({
    mode: 'history',
    routes
})
Vue.use(VueRouter)

Vue.mixin({
    data () {
        return {
            leftArrow: false,
            rightArrow: false,
            scrollable: false,
            phone: process.env.TEL,
            email: process.env.MAIL
        }
    },
    methods: {
        initEvents (id) {
            this.check(id)

            setTimeout(() => {
                this.check(id)
            }, 400)

            window.addEventListener('resize', () => {
                this.check(id)
            })

            document.querySelector('#' + this.id + ' .carousel-wrapper').addEventListener('scroll', () => {
                this.check(id)
            })
        },
        isScrollable (id) {
            this.scrollable = document.querySelector('#' + id + ' .carousel-wrapper') !== null && document.querySelector('#' + id + ' .carousel-wrapper').scrollWidth > document.querySelector('#' + id + ' .carousel-wrapper').clientWidth
        },
        showArrows (id) {
            this.leftArrow = this.scrollable && document.querySelector('#' + id + ' .carousel-wrapper').scrollLeft > 0
            this.rightArrow = this.scrollable && document.querySelector('#' + id + ' .carousel-wrapper').scrollWidth > (document.querySelector('#' + id + ' .carousel-wrapper').scrollLeft + document.querySelector('#' + id + ' .carousel-wrapper').clientWidth)
        },
        check (id) {
            this.isScrollable(id)
            this.showArrows(id)
        },
        scrollLeft (id) {
            document.querySelector('#' + id + ' .carousel-wrapper').scrollTo({
                top: 0,
                left: document.querySelector('#' + id + ' .carousel-wrapper').scrollLeft - 250,
                behavior: 'smooth'
            })
        },
        scrollRight (id) {
            document.querySelector('#' + id + ' .carousel-wrapper').scrollTo({
                top: 0,
                left: document.querySelector('#' + id + ' .carousel-wrapper').scrollLeft + 250,
                behavior: 'smooth'
            })
        },
        mailto () {
            this.$refs.mailto.$el.href += this.email
        },
        tel () {
            this.$refs.tel.$el.href += this.phone
        },
        isCurrentTab (tab) {
            return tab === this.$route.name
        }
    }
})

/* eslint-disable no-new */
export const vm = new Vue({
    el: '#app',
    router,
    store,
    vuetify,
    components: {
        app: App
    },
    render: h => h('app')
})



// WEBPACK FOOTER //
// ./src/main.js